class UpdateQuantity {
  qtdDisponivel = 0;
  select = null;
  customInput = null;
  inputQuantidade = null;

  constructor(qtdDisponivel) {
    this.qtdDisponivel = qtdDisponivel;
  }

  hasQuantity() {
    if (!this.qtdDisponivel || this.qtdDisponivel <= 0) return false;

    return true;
  }

  getSelectComponent() {
    const select = document.querySelector("#custom-quantity-container");

    if (!select) return null;

    select.innerHTML = "";

    this.select = select;

    return select;
  }

  handleSelectEvents() {
    this.select.addEventListener("change", (e) => {
      if (e.target.value === "more") {
        console.log(e.target);
        // Mostrar campo personalizado e focar nele
        this.customInput.style.display = "inline-block";
        this.customInput.focus();

        // Limpar valor do input principal temporariamente
        this.inputQuantidade.value = "";
      } else {
        // Ocultar campo personalizado
        this.customInput.style.display = "none";
        this.customInput.value = "";

        // Atualizar input principal
        this.inputQuantidade.value = e.target.value;
      }
    });
  }

  getQuantityInputComponent() {
    const inputQuantidade = document.querySelector("#TxtQtdAdd");

    if (!inputQuantidade) return null;

    // Define valor inicial do input com o valor atual do select
    inputQuantidade.value = this.select.value;

    this.inputQuantidade = inputQuantidade;
    return inputQuantidade;
  }

  createOptions() {
    // Criar opções de 1 até 10 ou até a quantidade disponível (se menor que 10)
    const maxOptions = Math.min(10, this.qtdDisponivel);

    for (let i = 1; i <= maxOptions; i++) {
      const option = document.createElement("option");
      option.value = i;
      option.textContent = i == 1 ? `${i} unidade` : `${i} unidades`;
      this.select.appendChild(option);
    }

    // Adicionar opção "mais que 10" se a quantidade disponível for maior que 10
    if (this.qtdDisponivel > 10) {
      const option = document.createElement("option");
      option.value = "more";
      option.textContent = "outro valor";
      this.select.appendChild(option);
    }
  }

  createCustomInput() {
    const vrfCustomInput = document.querySelector(
      "#custom-quantity-container__custom-quantity-input"
    );

    if (vrfCustomInput) return;

    const customInput = document.createElement("input");

    customInput.id = "custom-quantity-container__custom-quantity-input";
    customInput.type = "text";
    customInput.maxLength = 2;
    customInput.style.display = "none";
    customInput.placeholder = "Qtd";

    // Permitir apenas números
    customInput.addEventListener("input", (e) => {
      e.target.value = e.target.value.replace(/[^0-9]/g, "");
    });

    // Inserir o input após o select
    this.select.parentNode.insertBefore(customInput, this.select.nextSibling);

    this.customInput = customInput;
  }

  handleCustomInputEvents() {
    // Evento para quando o campo personalizado perde o foco
    this.customInput.addEventListener("blur", (e) => {
      const valor = parseInt(e.target.value);

      if (
        !e.target.value ||
        isNaN(valor) ||
        valor <= 10 ||
        valor > this.qtdDisponivel
      ) {
        // Voltar para o select se:
        // - Campo vazio
        // - Não é número
        // - Valor <= 10 (deveria usar o select normal)
        // - Valor maior que disponível
        this.customInput.style.display = "none";
        this.customInput.value = "";
        this.select.value = "1"; // Volta para primeira opção
        this.inputQuantidade.value = "1";
      } else {
        // Valor válido
        this.inputQuantidade.value = valor;
      }
    });

    // Evento para tecla Enter no campo personalizado
    this.customInput.addEventListener("keypress", (e) => {
      if (e.key === "Enter") {
        this.customInput.blur(); // Trigger do evento blur
      }
    });
  }

  run() {
    if (!this.hasQuantity()) return;

    const select = this.getSelectComponent();
    const inputQuantidade = this.getQuantityInputComponent();

    if (!select || !inputQuantidade) return;

    this.createOptions();
    this.createCustomInput();
    this.handleCustomInputEvents();
    this.handleSelectEvents();
  }
}

class WsAbstractions {
  variations = wsMain?.globalData?.infoProduto?.variacoes;

  hasVariations() {
    if (!!wsMain?.globalData?.infoProduto?.variacoes?.length) return true;

    return false;
  }

  watchingProdCode(callback) {
    const element = document.querySelector('[data-wsjs-product="code"]');

    if (!element) {
      console.warn('Elemento [data-wsjs-product="code"] não encontrado.');
      return;
    }

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === "childList" ||
          mutation.type === "characterData"
        ) {
          callback(element.textContent.trim());
        }
      }
    });

    observer.observe(element, {
      characterData: true,
      childList: true,
      subtree: true,
    });

    // Chama o callback inicialmente com o valor atual
    callback(element.textContent.trim());

    return observer; // permite desconectar depois, se quiser
  }

  getVariationQuantity(code) {
    const [elm] = this.variations.filter(
      (variation) => variation.codigo == code
    );

    return elm?.estoque;
  }
}

function atualizarQuantidadeDisponivel() {
  const qtdDisponivel = wsMain?.globalData?.infoProduto?.qtd_disponivel;

  const updateQuantity = new UpdateQuantity(qtdDisponivel);

  updateQuantity.run();

  const ws = new WsAbstractions();
  const hasVariations = ws.hasVariations();

  if (hasVariations) {
    ws.watchingProdCode((code) => {
      const newQtdDisponivel = ws.getVariationQuantity(code);

      const newUpdateQuantity = new UpdateQuantity(newQtdDisponivel);

      newUpdateQuantity.run();
    });
  }
}

try {
  isReady("pag-produto", atualizarQuantidadeDisponivel);
} catch (error) {
  console.log("Debug ~ error:", error);
}

function transformaDescricaoEmMenu() {
  try {
    const containers = document.querySelectorAll(
      ".prod-main-block-descriptions"
    );
    if (!containers || !containers.length) return;

    containers.forEach((div) => {
      const h2 = div.querySelector("h2");
      const contentDiv = div.querySelector(
        ".prod-description-container > div > div"
      );
      contentDiv.style.position = "relative";

      if (h2 && contentDiv) {
        if (h2.textContent.includes("Descrição")) {
          // contentDiv.style.maxHeight = contentDiv.scrollHeight + "px";
          contentDiv.style.maxHeight = 120 + "px";
          const emptyDiv = document.createElement("div");
          emptyDiv.classList.add("description-fade-btn-container");
          emptyDiv.classList.add("description-fade-btn-container__event");
          emptyDiv.innerHTML =
            '<svg class="description-fade-btn-container__event" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path class="description-fade-btn-container__event" d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/></svg>';
          contentDiv.appendChild(emptyDiv);
        }

        addToggleOverlay(h2, contentDiv);
      }
    });

    const featuresTable = document.querySelector(
      '[data-wsjs-product="features"]'
    );
    if (featuresTable) {
      const contentDiv = document.createElement("div");
      const clonedTable = featuresTable.querySelector("table").cloneNode(true);
      contentDiv.appendChild(clonedTable);
      const h2 = featuresTable.querySelector("h2");
      h2.style.position = "relative";

      addToggleOverlay(h2, contentDiv);
      featuresTable.appendChild(contentDiv);

      contentDiv.style.maxHeight = contentDiv.scrollHeight + "px";

      // Hide the original table
      featuresTable.querySelector("table").style.display = "none";
    }
  } catch (error) {
    console.log("error aq1: ", error);
  }
}

function addToggleOverlay(headerElement, contentElement) {
  try {
    const overlay = document.createElement("div");
    overlay.classList.add("custom-overlay-toggle-btn");

    const icon = document.createElement("span");
    icon.innerHTML = `
      <svg class="custom-svg-catego" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <path id="Caminho_10031" data-name="Caminho 10031" d="M700,1987v14m-7-7h14" transform="translate(-692 -1986)" fill="none" stroke="#343a40" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
      </svg>
    `;
    overlay.style.cursor = "pointer";

    headerElement.appendChild(icon);
    headerElement.appendChild(overlay);

    const btnArrowDown = contentElement.querySelector(
      ".description-fade-btn-container"
    );

    const toggleContent = (customHeight = false, e) => {
      if (
        contentElement.style.maxHeight == "0px" ||
        contentElement.style.maxHeight == "120px"
      ) {
        contentElement.style.maxHeight = contentElement.scrollHeight + "px";
      } else {
        contentElement.style.maxHeight = customHeight ? `${customHeight}px` : 0;
      }
      if (
        !e &&
        btnArrowDown &&
        headerElement.textContent.includes("Descrição")
      ) {
        btnArrowDown.style.display = "none";
      }
      if (
        e &&
        e.target &&
        e.target.classList.contains("description-fade-btn-container__event")
      )
        btnArrowDown.style.display = "none";
    };

    overlay.addEventListener("click", () => {
      toggleContent();
    });

    if (btnArrowDown) {
      btnArrowDown.addEventListener("click", (e) => {
        toggleContent(120, e);
      });
    }

    // Initially hide the content with smooth animation
    if (headerElement.textContent.includes("Descrição")) {
      contentElement.style.maxHeight = "120px";
    } else {
      contentElement.style.maxHeight = "0";
    }
    contentElement.style.overflow = "hidden";
    contentElement.style.transition = "max-height 600ms ease-out";
  } catch (error) {
    console.log("error aq2: ", error);
  }
}

function customReviewsOrderby() {
  const timesToTry = 3;
  let tried = 0;

  function createCustomSelect() {
    const reviewSelect = document.querySelector(
      "select.reviews-filters-container"
    );

    if (!reviewSelect && tried < timesToTry) {
      tried += 1;
      setTimeout(createCustomSelect, 1000);
      return;
    }

    if (!reviewSelect) {
      console.warn("Select não encontrado após 3 tentativas.");
      return;
    }

    reviewSelect.style.display = "none";

    const customContainer = document.createElement("div");
    customContainer.className = "custom-review-select";

    Array.from(reviewSelect.options).forEach((option) => {
      const optionDiv = document.createElement("div");
      
      optionDiv.textContent = option.text;
      optionDiv.className = "custom-review-select__item";

      if (option.selected) {
        optionDiv.classList.add("custom-review-select__actual-selected");
      }

      optionDiv.addEventListener("click", () => {
        reviewSelect.value = option.value;

        const changeEvent = new Event("change", { bubbles: true });
        reviewSelect.dispatchEvent(changeEvent);

        customContainer.querySelectorAll("div").forEach((div) => {
          div.classList.remove("custom-review-select__actual-selected");
        });
        optionDiv.classList.add("custom-review-select__actual-selected");
      });

      customContainer.appendChild(optionDiv);
    });

    reviewSelect.parentNode.insertBefore(
      customContainer,
      reviewSelect.nextSibling
    );
  }

  createCustomSelect();
}

function addVideoDescription() {
  const prod = wsMain.globalData.infoProduto;
  console.log(prod);
  if (!prod && !prod.video) return;
  const div = document.createElement("div");

  let ytVideoCode = wsMain.data.getYouTubeVideoId(prod.video);
  console.log(ytVideoCode);
  if (ytVideoCode) {
    let frameHTML = wsMain.tools.createElm({
      type: "div",
      attrs: {
        class: "pseudo-youtube-frame",
        videoCode: ytVideoCode,
      },
      innerHTML: `<img src="//i.ytimg.com/vi_webp/${ytVideoCode}/sddefault.webp" alt="thumbnail do video do youtube"><button class="ytp-large-play-button ytp-button ytp-large-play-button-red-bg" aria-label="Reproduzir"><svg height="100%" version="1.1" viewBox="0 0 68 48" width="100%"><path class="ytp-large-play-button-bg" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#f00"></path><path d="M 45,24 27,14 27,34" fill="#fff"></path></svg></button>`,
    });

    div.appendChild(frameHTML);
  }
  console.log(div);
  const description = document.querySelector(
    "#prod-description-block .prod-description-container > div > div"
  );
  console.log(description);
  if (description) {
    description.appendChild(div);
    try {
      document
        .querySelectorAll(".pseudo-youtube-frame")
        .forEach((el) => wsMain.addons.replaceIframe(el));
    } catch (err) {}
  }
}

try {
  isReady("pag-produto", addVideoDescription);
} catch {}

try {
  isReady("pag-produto", customReviewsOrderby);
} catch {}

try {
  isReady("pag-produto", transformaDescricaoEmMenu);
} catch (error) {
  console.log("Debug ~ error:", error);
}

function cloneCloseButton() {
  const originalCloseButton = document.querySelector(
    ".ws-modal-parcelas .ws-modal-parcelas-close"
  );
  const contentContainer = document.querySelector(
    ".ws-modal-parcelas .ws-modal-parcelas-content"
  );

  if (!originalCloseButton || !contentContainer) {
    console.warn("Elemento não encontrado");
    return;
  }

  // Clona o botão
  const newBtn = document.createElement("span");
  newBtn.classList.add("ws-modal-parcelas-close");
  newBtn.classList.add("clonedBtn");

  // newBtn.setAttribute('onclick', "wsMain.modules['pag-produto'].modalInstalments()")

  newBtn.addEventListener("click", () => {
    const modal = document.querySelector(".ws-modal-parcelas");
    modal.classList.add("modalInstallmentClosed");
    setTimeout(() => {
      wsMain.modules["pag-produto"].modalInstalments();
    }, 400);
  });

  newBtn.innerHTML = `
  <svg xmlns="http://www.w3.org/2000/svg" width="14.828" height="14.828" viewBox="0 0 14.828 14.828">
    <path id="Caminho_8519" data-name="Caminho 8519" d="M978,2308l-12,12m0-12,12,12" transform="translate(-964.586 -2306.586)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
  </svg>
  `;

  // Insere o clone no final do conteúdo
  contentContainer.appendChild(newBtn);

  // Oculta o botão original
  originalCloseButton.style.display = "none";
}

function openInstallmentModal() {
  document
    .querySelector('[data-wsjs-product="installments"] > a')
    .addEventListener("click", (e) => {
      console.log(e.target)
      const modal = document.querySelector(".ws-modal-parcelas");
      modal.classList.remove("modalInstallmentClosed");
    });
}

function removeVideo() {
  document.querySelectorAll('.iframe-overlay').forEach(iframe => {
    iframe.parentNode.style.display= 'none';
  })
}

try {
  isReady("pag-produto", removeVideo);
} catch {}


try {
  isReady("pag-produto", cloneCloseButton);
} catch {}

// try {
//   isReady("pag-produto", openInstallmentModal);
// } catch {}

// Essa página não tem data-wsjs-product="photos" (não usa o slider principal
// com miniaturas separadas) — mostra todas as fotos abertas via
// data-wsjs-product="dots" em modo lista (data-wsjs-options="list:true").
// O ZoomPlugin/openModalPlugin padrão de wsapi3-pag-prod-rules.js só liga
// quando existe o slider "photos", então nunca dispara aqui, e o clique nas
// fotos não fazia nada (o próprio wsapi3-pag-prod-rules.js já tenta mover
// photoSlider.moveToIdx(idx) num try/catch que sempre falha silenciosamente
// porque photoSlider é null nessa estrutura). Reimplementamos aqui: clicar
// numa foto abre o modal (wsapi3-pag-prod-rules.js já constrói o modalSlider
// normalmente a partir de data-wsjs-product="modal") já no índice clicado.
function bindDotsClickOpenModal() {
  const modalContainer =
    document.querySelector("[data-wsjs-productmodal]") ||
    document.querySelector('[data-wsjs-product="modal"]');

  if (!modalContainer) return;

  document
    .querySelectorAll('[data-wsjs-product="dots"] [data-dot-index]')
    .forEach((dot) => {
      // não mexe nas miniaturas que já ficam DENTRO do próprio modal
      if (dot.closest('[data-wsjs-productmodal], [data-wsjs-product="modal"]'))
        return;
      if (dot.__wsOpenModalBound) return;
      dot.__wsOpenModalBound = true;

      dot.addEventListener("click", () => {
        const idx = Number(dot.getAttribute("data-dot-index")) || 0;

        try {
          document.addEventListener(
            "keyup",
            wsMain.modules["pag-produto"].closeModal,
            false,
          );
        } catch (error) {}

        modalContainer.setAttribute("style", "display: flex;");

        setTimeout(() => {
          modalContainer.setAttribute("style", "display: flex; opacity: 1;");

          try {
            const modalSlider =
              wsMain.modules["pag-produto"].cache?.slides?.modalSlider;
            if (modalSlider) {
              modalSlider.update();
              modalSlider.moveToIdx(idx);
            }
          } catch (error) {}
        }, 50);
      });
    });
}

try {
  isReady("pag-produto", bindDotsClickOpenModal);
} catch (error) {}

// wsapi3-pag-prod-rules.js já cria o botão "X" (.close-button) sozinho ao
// montar o modal — só faltava fechar ao clicar no fundo escuro. O modal em
// si (data-wsjs-product="modal") É o backdrop: position:fixed cobrindo a
// tela inteira, com o keen-slider centralizado dentro dele.
function setupModalBackdropClose() {
  const modalContainer =
    document.querySelector("[data-wsjs-productmodal]") ||
    document.querySelector('[data-wsjs-product="modal"]');

  if (!modalContainer || modalContainer.__wsBackdropCloseBound) return;
  modalContainer.__wsBackdropCloseBound = true;

  modalContainer.addEventListener("click", (event) => {
    if (event.target !== modalContainer) return;
    try {
      wsMain.modules["pag-produto"].closeModal();
    } catch (error) {}
  });
}

try {
  isReady("pag-produto", setupModalBackdropClose);
} catch (error) {}
